import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

const ROUTES = {
  BOOKING_REQUEST: '/booking-request/[id]',
  BOOKING_SUCCESS: '/booking-request/success/[id]',
  PAYMENT_SUCCESS: '/payment/success/[bookingId]/[bookingSecret]'
};

const CUSTOM_STYLES_PER_ROUTE = {
  [ROUTES.BOOKING_REQUEST]: {
    visibility: {
      mobile: {
        position: 'br',
        xOffset: '20px',
        yOffset: '112px'
      }
    }
  },
  [ROUTES.BOOKING_SUCCESS]: {
    visibility: {
      mobile: {
        position: 'br',
        xOffset: '20px',
        yOffset: '86px'
      }
    }
  },
  [ROUTES.PAYMENT_SUCCESS]: {
    visibility: {
      mobile: {
        position: 'br',
        xOffset: '20px',
        yOffset: '86px'
      }
    }
  },
  DEFAULT: {
    visibility: {
      mobile: {
        position: 'br',
        xOffset: '20px',
        yOffset: '20px'
      }
    }
  }
};

const TawkTo = () => {
  const { pathname } = useRouter();

  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = CUSTOM_STYLES_PER_ROUTE[pathname] || CUSTOM_STYLES_PER_ROUTE.DEFAULT;
  }, [pathname]);

  return (
    <Script
      async
      defer
      strategy="lazyOnload"
      src={`https://embed.tawk.to/${process.env.TAWKTO_PROPERTY_ID}/${process.env.TAWKTO_CHAT_ID}`}
    />
  );
};

export default TawkTo;
